import { render } from "./CompanySection.vue?vue&type=template&id=dc90cec6&scoped=true"
import script from "./CompanySection.vue?vue&type=script&lang=js"
export * from "./CompanySection.vue?vue&type=script&lang=js"

import "./CompanySection.vue?vue&type=style&index=0&id=dc90cec6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc90cec6"]])

export default __exports__